import React, { useState } from 'react'
import { AuthRemider } from '../components/Modal/AuthReminder'
import { useSelector } from 'react-redux'
import { userSelectors } from '../redux/userSlice'

export function useAuthReminderModal(redirectUrl) {
    const [show, setShow] = useState(false)

    const isLoggedIn = useSelector(userSelectors.isLoggedIn)

    function renderModal() {
        return (
            <AuthRemider
                open={show}
                redirectUrl={redirectUrl}
                onRequestDismiss={() => setShow(false)}
            />
        )
    }

    function conditionallyShowModal(callback) {
        if (isLoggedIn) return callback
        else return () => setShow(true)
    }

    return { renderModal, conditionallyShowModal }
}
